import TUploader from "./TUploader";

export default TUploader;
